<template>
  <div id="app">
	<Header :cid="Cid" ></Header>
    <el-carousel height="556px">
	  <el-carousel-item v-for="item in bannerData" :key="item.id">
		<img :src="item.image" />
	  </el-carousel-item>
    </el-carousel>
	<div class="idx-1200-box">
		<div class="idx-info">
			<div class="idx-info-head">
				<hr class="idx-info-head-bar"><p>公司简介</p><hr class="idx-info-head-bar">
			</div>
			<p class="idx-info-content">{{idx_desc}}<a href="/company_desc">[详情]</a></p>
	     <div  class="idx-info-bott">
			 <img v-for="(item,index) in desc_pic" :key="index" :src="item" />
		 </div>
		</div>
	</div>
	<div class="idx-swiper-four">
	  <div class="idx-swiper-four-box">
		<div class="idx-swiper-four-head">
			<img src="/src/assets/images/254.png" />
			<p>园陵墓型</p>
			<img src="/src/assets/images/521.png" />
		</div>
		<el-carousel ref="graveSwiperArrow" arrow='never' :autoplay="false"  height="237px" indicator-position='none' style="width: 1200px;">
		  <el-carousel-item class="idx-swiper-four-one"  v-for="(item,index) in graveData" :key="item.id">
			<img v-if="item.length>0" v-for="(items,idx) in item" :key="idx" :src="items.pic[0]" :alt="items.name" @click="go_detail(items.id)" :title="items.name" />
		  </el-carousel-item>
		</el-carousel>
		<div class="grave-swiper-arrow">
			<img @click="graveSwiperArrow('left')" src="../assets/images/5412.png" />
			<img @click="graveSwiperArrow('right')" src="../assets/images/5412.png" />
		</div>
		<a class="idx-swiper-four-head-bott-btn">查看全部</a>
	   </div>
	</div>
	<div class="idx-garden-show">
		<div class="idx-garden-show-box">
			<div class="idx-garden-show-box-lef">
				<div class="idx-garden-show-box-lef-head">
					<h3>园陵景观</h3>
					<a href="/garden_show">更多+</a>
				</div>
				<el-carousel width='556' height="439px" class="idx-garden-show-box-lef-conte" arrow="never" indicator-position='none' ref="gardenShowArrow">
				  <el-carousel-item style="height: 439px;" v-for="item in gardenData" :key="item.id">
					<img  :src="item.pic" />
				  </el-carousel-item>
				</el-carousel>
				<div class="garden-show-arrow">
				   <img @click="gardenShowArrow('left')" src="../assets/images/02.png" />
				   <img @click="gardenShowArrow('right')" src="../assets/images/02.png" />
				</div>
			</div>
			<div class="idx-garden-show-box-rig">
				<div class="idx-garden-show-box-lef-head">
					<h3 @click="aa">园陵资讯</h3>
					<a href="/news">更多+</a>
				</div>
				<div class="idx-garden-show-box-rig-bott">
					<el-carousel height="439px" direction="vertical" :autoplay="false" arrow="never" indicator-position='none' ref="newsShowArrow">
					  <el-carousel-item style="height: 439px;" v-for="item in recomNewsData" :key="index">
						<div v-for="(items,idx) in item" :key="idx" class="idx-garden-show-box-rig-bott-one">
							<img src="../assets/images/index_20.png" />
							<div class="idx-garden-show-box-rig-bott-one-rig">
								<h3>{{items.title}}</h3>
								<p>{{items.description}}</p>
								<a :href="'/detail_page?id='+items.id+'&type=2&sid=9'">查看详情</a>
							</div>
						</div>
					  </el-carousel-item>
					</el-carousel>

				</div>
				<div class="idx-garden-show-box-rig-bott-box">
					<img @click="newsShowArrow('left')" src="/src/assets/images/03.png" />
					<img @click="newsShowArrow('right')" src="/src/assets/images/04.png" />
				</div>
			</div>
		</div>
	</div>
	
	<div class="idx-contact">
		<div class="idx-contact-box">
			<div class="idx-contact-lef">
				<h2>陵 园 志</h2>
				<p>  鸿龙寨陵园坐落于鸿龙山麓，山势如巨龙蜿蜒，雄伟神奇。陵园北依玄武，东西青龙白虎辅弼，前有明堂，远有案山。得天地之灵气，萃日月之精华，承星辰之泽露，集风水之大成，实乃人间之龙脉宝地，亡灵之天堂家园。</p>
				<p> 陵园距市区九公里，交通便捷。公路沿线景色优美，民风淳朴；陵区苍松翠柏，庄严肃穆。拜谒之余，尚有杏花小酌，身承清明雨，心有三春晖，远离尘世之喧嚣，皈依灵魂之净土，纵两世殊途，冥冥中心有灵犀，夫复何求？</p>
				<p>  陵园方圆千余亩，十载绿化，福荫子孙，保持水土，利国利民。尊关帝英灵，扬忠义气节，建慈恩祭台，传人伦孝悌。更新辟天梯，一径独上南天门。登高远眺，汉江苍茫迷朦，俯首垂思，世事红尘滚滚，揽物则胜景入怀，抒臆皆慷慨之志，陵园与风景胜地浑然一体，仙人流连忘返，翔龙驻足伏卧，此鸿龙山之由来也！
山如斯，园如斯，心何往？ <a href="/company_desc?sid=14">[详情]</a></p>
			 <img :src="site_idx_grave_words_pic"  />
			</div>
		    <div class="idx-contact-rig">
				<h3>联系我们</h3>
				<p>总   公  司: 0915-3208448  (兴科金地)</p>
				<p>城区分公司: 0915-3238555  (康城步行街口)</p>
				<p>江北分公司: 0915-3318448  ( 江北办事处政务大厅隔壁)</p>
				<p>陵园接待处: 0915-3238448  ( 江北办朱家湾村)</p>
				<baidu-map 
				class="map"
				:scroll-wheel-zoom="true"
				:center="center"
				:zoom="zoom"
				@moving="syncCenterAndZoom"
				@moveend="syncCenterAndZoom"
				@zoomend="syncCenterAndZoom">
				<bm-marker :position="{lng: 109.008296, lat:32.765564}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
				   <bm-label content="鸿龙寨公墓" labelStyle="{color: 'red', fontSize : '15px'}" :offset="{width: -35, height: 30}"/>
				</bm-marker>
				  <bm-point-collection v-if="points.length>0" :points="points" shape="BMAP_POINT_SHAPE_STAR" color="red" size="BMAP_POINT_SIZE_NORMAL" @click="clickHandler"></bm-point-collection>
				</baidu-map>
			</div>
		</div>
	</div>
	<Footer :Idx_bott_wxqrcode="idx_bott_wxqrcode" :Idx_bott_logo="idx_bott_logo"  :Classdata="classData" :Copyright="copyright" :Recordno="record_No"></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import { listGrave,getBanner,getIndexData } from '../api/index'
import { InfoClassApi } from '../api/info_class'
import { InfoListApi } from '../api/info_list'
import { InfoApi } from '../api/info'

export default {
 components: {
    Header,
	Footer
  },
  mixins: [Header, Footer],
  data () {
      return {
          bannerData: [],
		  graveData:[],
		  gardenData:[],
		  recomNewsData:[],
		  classData:[],
		  map: Object,
		   center: {
			   lng: 109.008296,
			   lat: 32.765564
		  },
		  zoom: 11,
		  points: [],
		  Cid:1,
		  idx_desc:'',
		  desc_pic:[],
		  site_idx_grave_words_pic:'',
		  logoUrl:'',
		  record_No:'',
		  // copyright:'',
		  idx_bott_wxqrcode:'',
		  idx_bott_logo:'',
      }
  },
  
  methods: {
    startHacking () {
      this.$notify({
        title: '提示!',
        type: 'error',
        message: 'We\'ve laid the ground work for you. It\'s time for you to build something epic!',
        duration: 5000
      })
    },
	aa(){
		var that = this;
		listGrave().then(res => {
			console.log(res)
			if(res.status==200){
				console.log(111)
				that.graveData = res.data.list;
			}
		}).catch(res => {
			that.$notify({
			  title: '提示!',
			  type: 'error',
			  message: res,
			  duration: 5000
			})
		})
	},
	graveSwiperArrow(val){
	  if(val=== 'right'){
		  this.$refs.graveSwiperArrow.next();
	  }else{
		  this.$refs.graveSwiperArrow.prev();
	  }
	},
	gardenShowArrow(val){
		if(val=== 'right'){
			this.$refs.gardenShowArrow.next();
		}else{
			this.$refs.gardenShowArrow.prev();
		}
	},
	newsShowArrow(val){
	   if(val=== 'right'){
	   	this.$refs.newsShowArrow.next();
	   }else{
	   	this.$refs.newsShowArrow.prev();
	   }
	},
	syncCenterAndZoom (e) {
	      const {lng, lat} = e.target.getCenter()
	      this.center.lng = lng
	      this.center.lat = lat
	      this.zoom = e.target.getZoom()
    },
	clickHandler (e) {
	      alert(`单击点的坐标为：${e.point.lng}, ${e.point.lat}`);
	},
	addPoints () {
	  const points = [];
	  const position1 = {lng:109.008296, lat:32.765564}
	  points.push(position1);
	  this.points = points
    },
	go_detail(id){
		window.location.href="/detail_page?id="+id+"&sid=5&type=4";
	}
  }, 
  mounted() {
      const _this = this
      this.$nextTick(() => {
      })
	   this.addPoints();  

	  InfoApi().then(res => {
	  	console.log(res)
	  	if(res.status==200){
	  		console.log(111)
	  		_this.graveData = res.data.list;
	  	}
	  }).catch(res => {
	  	_this.$notify({
	  	  title: '提示!',
	  	  type: 'error',
	  	  message: res,
	  	  duration: 5000
	  	})
	  })  
	  
	  // getIndexData().then(res => {
	  // 	console.log(res)
	  // 	if(res.status==200){
	  // 		console.log(111)
	  // 		_this.bannerData = res.data.banner;
			// _this.gardenData = res.data.graden_show.list;
			// _this.graveData = res.data.grave_show.list;
			// _this.newsData = res.data.recom_news.list;
			// // _this.classData = res.data.siteclass.list;
			// _this.idx_desc = res.data.idx_desc;
			// _this.desc_pic = res.data.desc_pic;
			// _this.site_idx_grave_words_pic = res.data.site_idx_grave_words_pic; 
			
			// // _this.logoUrl = res.data.logoUrl; 
			// // _this.record_No = res.data.record_No; 
			// // _this.copyright = res.data.copyright; 
			// // _this.idx_bott_logo = res.data.idx_bott_logo; 
			// // _this.idx_bott_wxqrcode = res.data.idx_bott_wxqrcode; 
	  // 	}
	  // }).catch(res => {
	  // 	_this.$notify({
	  // 	  title: 'It works!',
	  // 	  type: 'success',
	  // 	  message: res,
	  // 	  duration: 5000
	  // 	})
	  // })   
  },
}
</script>
  
<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}
</style>
<style>
	@import url("/src/assets/style/style.css");
</style>


// WEBPACK FOOTER //
// src/pages/index.vue